<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiFolderRefreshOutline } from "@mdi/js";
export default {
  name: "MdiFolderRefreshOutline",
  data() {
    return {
      svgPath: mdiFolderRefreshOutline,
    };
  },
};
</script>
